import { useCallback, useSyncExternalStore } from 'react';

// Below Tailwind's `md` and `lg` breakpoints, written exactly like its `max-md` / `max-lg` variants
// so JS and CSS agree at every width. They match "narrower than", so where matchMedia matches
// nothing (tests, old browsers) the app falls back to the desktop layout.
const PHONE_QUERY = '(width < 48rem)';
const BELOW_DESKTOP_QUERY = '(width < 64rem)';

/** Whether a media query matches, kept in sync as the window changes. */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [query]
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false
  );
}

/** Phone layout: under 768px wide. */
export const useIsPhone = () => useMediaQuery(PHONE_QUERY);

/** Phone or tablet layout: under 1024px wide. */
export const useIsBelowDesktop = () => useMediaQuery(BELOW_DESKTOP_QUERY);
